import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { homeBreadcrumbItem, useBreadcrumbsService } from 'shared/UI/UIKit/Breadcrumbs';
import { getEducationPlansUrl, type EducationPlanPageParams } from 'services/navigation';
import { getCurriculumById, type Curriculum } from 'services/api/educationPlans';

const getEducationPlanBreadcrumbs = (educationPlanName: string) => {
  return [
    homeBreadcrumbItem,
    {
      title: 'Учебные планы',
      url: getEducationPlansUrl(),
    },
    {
      title: educationPlanName,
      url: '',
    },
  ];
};

export const useEducationPlanPage = () => {
  const { educationPlanId } = useParams<EducationPlanPageParams>();
  const breadcrumbsService = useBreadcrumbsService();
  const [educationPlan, setEducationPlan] = useState<Curriculum | null>(null);

  useEffect(() => {
    if (educationPlanId && educationPlanId !== 'new') {
      breadcrumbsService.setBreadcrumbsLoading(true);

      getCurriculumById(educationPlanId).then((res) => {
        breadcrumbsService.setBreadcrumbs(getEducationPlanBreadcrumbs(res.name));
        setEducationPlan(res);
        breadcrumbsService.setBreadcrumbsLoading(false);
      });
    } else {
      breadcrumbsService.setBreadcrumbs(getEducationPlanBreadcrumbs('Новый учебный план'));
      setEducationPlan(null);
    }
  }, [educationPlanId]);

  return {
    breadcrumbs: breadcrumbsService.breadcrumbs,
    breadcrumbsLoading: breadcrumbsService.breadcrumbsLoading,
    educationPlan,
  };
};
